export const isRef = (obj: any): obj is { current: any } =>
  obj && 'current' in obj
